import React from "react";
import TextField from "@mui/material/TextField";
import "./TextInput.css";

const TextInput = (props) => {
  return <TextField size="small" className="input-style" {...props}  InputLabelProps={{ className: "visually-hidden" }}/>;
};

export default TextInput;
